import { Grid2 } from "@mui/material";
import TTChip from "./TTChip";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { safeJSONParse } from "../../../../Actions/utils";

const UIText = {
  "es-CL": { from: "De: ", to: "Para: " },
  "en-US": { from: "From: ", to: "To: " },
};

const FromTo = ({ fromM, toRecipients }) => {
  const { settings } = useUIBp();
  const { from, to } = UIText[settings.locale];

  const fromData = safeJSONParse(fromM, {}) ?? {};
  const toData = safeJSONParse(toRecipients, []);
  const toList = Array.isArray(toData) ? toData : [];
  const toArray = toList.map((data, idx) => (
    <TTChip {...{ key: idx, data: data?.emailAddress }} />
  ));

  return (
    <Grid2
      container
      {...{
        rowGap: 1,
        padding: 2,
        paddingTop: 1,
        paddingBottom: 1,
        borderTop: "1px solid lightgrey",
        borderBottom: "1px solid lightgrey",
      }}
    >
      <Grid2
        container
        {...{
          size: 12,
          columnGap: 1,
          rowGap: 0.5,
          alignItems: "center",
        }}
      >
        {from}
        <TTChip {...{ data: fromData.emailAddress }} />
      </Grid2>
      <Grid2
        container
        {...{
          size: 12,
          columnGap: 1,
          rowGap: 0.5,
          alignItems: "center",
        }}
      >
        {to}
        {toArray.length ? toArray : <TTChip {...{ data: undefined }} />}
      </Grid2>
    </Grid2>
  );
};

export default FromTo;
